import React from 'react'
import Adminnav from './Adminnav/Adminnav'
import Adminsec1 from './Adminsec1/Adminsec1'

export default function Index() {
  return (
    <>
      <Adminnav/>  
      <Adminsec1/> 
    </>
    )
}
